<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';

defineProps({
    curriculas: Array,
    columnas: Array,
    curriculadets: Array,
    columnadets: Array
});

const rutaPrefijo = ref('curricula');
const modulo = ref('Curricula');
const modulos = ref('Plan Curricular');// Curriculas
const tab = ref(0);
</script>

<template>

    <Head title="Plan curricular" />

    <BreezeAuthenticatedLayout>

        <template #header>
        <PremiumPageHeader title="Título" subtitle="Gestión de título">
            <template #buttons>
                <BaseButton :classLabel="'hidden sm:block'"
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-8 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                <BaseButton :classLabel="'hidden sm:block'"
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                <BaseButton :classLabel="'hidden sm:block'"
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
            </template>
        </PremiumPageHeader>
    </template>

        <div>
            <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                <template v-if="(tab == 0)">
                    <CardBox v-if="curriculadets.length" class="mb-6" has-table>
                        <!-- Tablesingle opciones: checkable -->
                        <TableAdvancedFilter :modulo="modulo" :modulos="modulos" :data="curriculadets" :fields="columnadets" :ruta="rutaPrefijo" exporteable />
                    </CardBox>
                    <CardBox v-else>
                        <CardBoxComponentEmpty />
                    </CardBox>
                </template>
                <template v-else-if="(tab == 1)">
                    <CardBox v-if="curriculas.length" class="mb-6" has-table>
                        <!-- Tablesingle opciones: checkable -->
                        <TableAdvancedFilter :modulo="modulo" :modulos="modulos" :data="curriculas" :fields="columnas" :ruta="rutaPrefijo" exporteable />
                    </CardBox>
                    <CardBox v-else>
                        <CardBoxComponentEmpty />
                    </CardBox>
                </template>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
